import {
  IAcademicsFrontEndModel,
  IDegreeWithAcademicBackEndModel,
} from "../../../types";
import { separateRequiredDocs } from "../../helpers/helperFunctions";

export function parseToFrontEndModel(
  backendModel: IDegreeWithAcademicBackEndModel[],
): IAcademicsFrontEndModel {
  const frontendModel = {} as IAcademicsFrontEndModel;

  backendModel.forEach((degree) => {
    if (!degree.academic) {
      frontendModel[degree.id] = {
        additionalDocuments: {},
        applicationForms: [],
        requiredDocs: [],
      };
    } else {
      const { requiredDocuments, additionalDocuments } = separateRequiredDocs(
        degree.academic.requiredDocs,
      );

      frontendModel[degree.id] = {
        additionalDocuments: additionalDocuments,
        requiredDocs: requiredDocuments,
        applicationForms: [],
      };

      frontendModel[degree.id].applicationForms =
        degree.academic.applicationForms!.map((af) => ({
          id: af.fileId,
          name: af.name!,
          size: af.size!,
          path: af.path!,
        }));

      if (degree.academic.applicationLink) {
        frontendModel[degree.id].applicationLink =
          degree.academic.applicationLink;
      }
    }
  });

  return frontendModel;
}
